import { render, staticRenderFns } from "./ChallengeTeam.vue?vue&type=template&id=08a5f5f2&scoped=true"
import script from "./ChallengeTeam.vue?vue&type=script&lang=ts"
export * from "./ChallengeTeam.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a5f5f2",
  null
  
)

export default component.exports